import script from "./DataCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./DataCenter.vue?vue&type=script&setup=true&lang=js"

import "./DataCenter.vue?vue&type=style&index=0&id=680abc60&lang=scss"

const __exports__ = script;

export default __exports__